export default __webpack_public_path__ + "824672ee6faffedfa09b36d584bddd8f.png";